<template>
  <section id="contact" :class="color" class="mt-0 grey lighten-4">
    <v-container class="extra-padding">
      <v-card
        min-height="560"
        width="100%"
        class="rounded-xl"
        style="overflow: hidden !important"
      >
        <v-row justify="center" class="mx-auto">
          <v-col cols="12" sm="7" md="8" class="px-md-10 px-xs-0">
            <v-card-title>
              <h3 class="primary--text font-weight-light">
                Envianos tu consulta
              </h3>
              <v-spacer></v-spacer>
              <v-icon x-large color="primary">mdi-email-newsletter</v-icon>
            </v-card-title>
            <contact-form />
          </v-col>
          <v-col cols="12" sm="5" md="4" class="primary alto">
            <v-card-title class="no-wrap">
              <h3 class="white--text font-weight-light">
                Informacón de Contacto
              </h3>
            </v-card-title>
            <contact-info />
          </v-col>
        </v-row>
      </v-card>
    </v-container>
  </section>
</template>

<script>
import ContactForm from "../../components/ContactForm.vue";
import ContactInfo from "../../components/ContactInfo.vue";
export default {
  name: "Contact",
  components: {
    ContactInfo,
    ContactForm
  },
  props: {
    color: {
      type: String,
      default: "grey lighten-4"
    }
  }
};
</script>

<style scoped>
.alto {
  min-height: 560px;
  height: auto;
}
</style>
